import React, { useState } from "react";
import "./mobileScroll.css";
import ScreenText from "./ScreenText";

const scrollData = [
  {
    heading: "smart investing made easy.",
    description:
      "our AI tracks markets 24/7 and finds good chances to grow your money across stocks, crypto, forex, and more.",
    mobile_img: "/images/feature1.png",
  },
  {
    heading: "stay updated always.",
    description:
      "get simple alerts on market moves, price changes, and big trends so you never miss what matters.",
    mobile_img: "/images/feature2.png",
  },
  {
    heading: "full control of your portfolio.",
    description:
      "see all your investments in one clean view. track profits, losses, and risk levels in real time.",
    mobile_img: "/images/feature3.png",
  },
  {
    heading: "fast and smooth execution.",
    description:
      "our system executes trades instantly, using advanced models to pick the best moments to enter or exit.",
    mobile_img: "/images/feature4.png",
  },
  {
    heading: "clear insights that help you grow.",
    description:
      "simple reports show where your money goes, how it performs, and how you can improve your returns.",
    mobile_img: "/images/feature5.png",
  },
  {
    heading: "built for all investors.",
    description:
      "invest in stocks, crypto, forex, bonds, and more with one platform built for both new and pro users.",
    mobile_img: "/images/feature6.png",
  },
];


const MobileScroll = () => {
  const [currentImg, setCurrentImg] = useState(0);
  return (
    <div className="flex max-width mobile-scroll">
      <div className="scroll-full-screen-wrapper">
        {scrollData.map((screen, i) => (
          <div className="scroll-full-screen">
            <ScreenText screen={screen} i={i} setCurrentImg={setCurrentImg} />
          </div>
        ))}
      </div>
      <div className="mobile-mockup-wrapper non-mobile">
        <div className="mobile-mockup">
          <div className="mobile-mockup-screen flex absolute-center">
            <img
              src={scrollData[currentImg].mobile_img}
              alt="image"
              className="mobile-screen-img slide-left"
              key={scrollData[currentImg].mobile_img}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileScroll;
